import * as React from 'react'
import { Grid, Typography } from '@mui/material'

export type GridItemProps = {
    label: string
    value: string
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    xl?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}

export default function GridItem({ label, value, xs, lg, sm, xl }: GridItemProps) {
    return (
        <Grid size={{ xs, lg, sm, xl }}>
            <Typography style={{ fontWeight: 'bold' }}>{label}:</Typography> <Typography>{value}</Typography>
        </Grid>
    )
}
